<template>
    <div class="main-box">
        <div class="page msg_success js_show">
            <div class="weui-msg">
                <div class="weui-msg__icon-area" :style="{opacity:opacity}">
                    <i class="weui-icon_msg weui-icon-success" v-if="success" ></i>
                    <i class="weui-icon_msg weui-icon-warn" v-if="!success"  ></i>
                </div>
                <p class="weui-msg__desc">{{msg}}</p>
                <div class="weui-msg__opr-area">
                    <p class="weui-btn-area">
                        <a href="javascript:void(0);" class="weui-btn weui-btn_primary" style="color:#fff" v-if="success" v-show="courseware" @click="goCourseware">进入课程</a>
                    </p>
                </div>
                <div class="weui-msg__extra-area">
                    <div class="weui-footer">
                        <p class="weui-footer__links">
                            <a href="javascript:void(0);" class="weui-footer__link">锐捷教育</a>
                        </p>
                        <p class="weui-footer__text">{{GLOBAL.copyright}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as cookie from '@static/js/cookieUtil.js';
	export default{
		data(){
			return{
                courseware : null,
                opacity : 0,
                success : false,
                commiting : true,
                userId : null,
                flag : false,
                coursewareId : null,
                content : '',
                msg : '正在提交...'
			}
        },
        filters:{

        },
		methods:{
            goCourseware : function(){
                this.$router.replace('/student/courseware/index/' + this.coursewareId + '/' + this.courseware.classId);
            },
            sign : function(){
                var _this = this;
                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/sign/app", _this.$qs.stringify({
                    userId : _this.userId,
                    mac : _this.mac,
                    coursewareId : _this.coursewareId
                })).then(function (response) {
                    _this.loading.hide();
                    _this.opacity = 1;
                    _this.success = response.data.success;
                    if(response.data.success){
						console.log("zmf class sign-app:sign")
                        _this.startLoop();//签到成功，开启轮询
                        weui.toast('签到成功');
                        _this.msg = '签到成功';
                    }else{
                        _this.msg = '签到失败';
                        _this.content = '去公众号使用签到码签到';
                        weui.alert(response.data.info);
                    }
                }).catch(function (error) {
                    _this.loading.hide();
                    _this.msg = '签到失败';
                });
            },
            loadData : function(){
                var _this = this;
                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/courseware/detail", _this.$qs.stringify({
                    coursewareId : _this.coursewareId
                })).then(function (response) {
                    if(!response.data.success){
                        return weui.alert(response.data.info);
                    }else{
                        _this.courseware = response.data.courseware;
                        _this.sign();
                    }
                }).catch(function (error) {
                    _this.loading.hide();
                });
            }
        },
		watch: {
		   '$route': 'onWatch'
		},
		mounted(){
            var _this = this;
            _this.schoolId = _this.$route.params.schoolId;
            _this.mac = _this.$route.params.mac;
            _this.coursewareId = _this.$route.params.coursewareId;
            _this.userId = cookie.getCookie("SC_COOKIE_USER_ID");
            _this.loadData();
		},
		beforeDestroy(){
		},
		destroyed(){
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-box{
    position: relative;
    height: 100%;
    padding-bottom: 1rem;
    box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/student/user/sign-app.vue